/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `MIN` - MIN
* `MAX` - MAX
* `RANGE` - RANGE
* `YES_NO` - YES_NO
 */
export type AllowedValueTypeEnum = typeof AllowedValueTypeEnum[keyof typeof AllowedValueTypeEnum];


export const AllowedValueTypeEnum = {
  MIN: 'MIN',
  MAX: 'MAX',
  RANGE: 'RANGE',
  YES_NO: 'YES_NO',
} as const;
